import { offeringKeys } from '@services/brokerage/offering/offering.keys';
import { useQueryClient, useMutation } from '@tanstack/react-query';
import { useClient } from '@utils/api-client';

export const useDeleteBrokerageOffering = () => {
  const queryClient = useQueryClient();
  const client = useClient();

  const mutationFn = (body: { brokerageId: string; brokerageOfferingId: string }) =>
    client.delete(`brokerage/${body.brokerageId}/brokerage-offering/${body.brokerageOfferingId}`);

  const result = useMutation({
    mutationFn,
    onSuccess: (data, variables) => {
      queryClient.invalidateQueries({ queryKey: offeringKeys.brokerageOfferingsSearch });
      queryClient.invalidateQueries({ queryKey: ['productOfferings', { brokerageId: variables.brokerageId }] });
    },
  });

  return { ...result, deleteBrokerageOffering: result.mutateAsync };
};
